// extracted by mini-css-extract-plugin
export default {"modal":"kO-z","modalOverlay":"lO-z","outfitHeading":"mO-z"};